var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSales1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3665 5.57325C16.2975 5.47356 16.2054 5.39207 16.098 5.33577C15.9907 5.27947 15.8712 5.25004 15.75 5.25H5.49975L4.63425 3.1725C4.52077 2.89892 4.3286 2.66519 4.08212 2.50096C3.83564 2.33673 3.54594 2.24938 3.24975 2.25H1.5V3.75H3.24975L6.80775 12.2888C6.86474 12.4254 6.96088 12.5421 7.08407 12.6241C7.20725 12.7062 7.35197 12.75 7.5 12.75H13.5C13.8127 12.75 14.0925 12.5558 14.2028 12.264L16.4528 6.264C16.4953 6.15047 16.5096 6.02832 16.4946 5.90802C16.4796 5.78771 16.4356 5.67285 16.3665 5.57325ZM12.9802 11.25H8.00025L6.12525 6.75H14.6677L12.9802 11.25Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 15.75C8.49632 15.75 9 15.2463 9 14.625C9 14.0037 8.49632 13.5 7.875 13.5C7.25368 13.5 6.75 14.0037 6.75 14.625C6.75 15.2463 7.25368 15.75 7.875 15.75Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15.75C13.7463 15.75 14.25 15.2463 14.25 14.625C14.25 14.0037 13.7463 13.5 13.125 13.5C12.5037 13.5 12 14.0037 12 14.625C12 15.2463 12.5037 15.75 13.125 15.75Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales1);
export default __webpack_public_path__ + "static/media/sales1.23021ef4f73377995e32612778f208c0.svg";
export { ForwardRef as ReactComponent };